// Re-export the shared hasPermission helper so scheduling pages only need one import
export { hasPermission } from './crmPermissions';

export const SCHEDULING_PERMISSIONS = {
  APPOINTMENT_READ: 'scheduling.appointment:read',
  APPOINTMENT_CREATE: 'scheduling.appointment:create',
  APPOINTMENT_UPDATE: 'scheduling.appointment:update',
  APPOINTMENT_CANCEL: 'scheduling.appointment:cancel',
  SCHEDULE_READ: 'scheduling.schedule:read',
  SCHEDULE_UPDATE: 'scheduling.schedule:update',
} as const;

export type SchedulingPermission =
  (typeof SCHEDULING_PERMISSIONS)[keyof typeof SCHEDULING_PERMISSIONS];
